module.exports = __webpack_public_path__ + "img/2.1.cd7ab3d7.png";